import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tw1_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 - only redirect for non-login requests, with debounce
let isRedirecting = false;

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      const isLoginRequest = err.config?.url?.includes('/api/auth/login');
      const isPasswordChange = err.config?.url?.includes('/api/auth/password');
      if (!isLoginRequest && !isPasswordChange && localStorage.getItem('tw1_token') && !isRedirecting) {
        isRedirecting = true;
        localStorage.removeItem('tw1_token');
        localStorage.removeItem('tw1_user');
        // Small delay to prevent multiple redirects
        setTimeout(() => {
          window.location.href = '/';
        }, 100);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
